import axiosInstance from './axiosConfig';

const generalLedgerAPI = {
  getAll: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/general-ledger', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch general ledger entries';
    }
  },

  getById: async (id) => {
    try {
      const response = await axiosInstance.get(`/general-ledger/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch general ledger entry';
    }
  },

  // General ledger specific methods
  getByAccount: async (accountId, params = {}) => {
    try {
      const response = await axiosInstance.get(`/general-ledger/account/${accountId}`, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch general ledger by account';
    }
  },

  getByDateRange: async (startDate, endDate, params = {}) => {
    try {
      const response = await axiosInstance.get('/general-ledger', {
        params: { startDate, endDate, ...params }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch general ledger by date range';
    }
  },

  getTrialBalance: async (asOfDate, accountingClientId = null, fiscalYear = null) => {
    try {
      const response = await axiosInstance.get('/general-ledger/trial-balance', {
        params: { 
          asOfDate,
          ...(accountingClientId && { accountingClient: accountingClientId }),
          ...(fiscalYear && { fiscalYear })
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch trial balance';
    }
  },

  getBalanceSheet: async (asOfDate, accountingClientId = null, fiscalYear = null) => {
    try {
      const response = await axiosInstance.get('/general-ledger/balance-sheet', {
        params: { 
          asOfDate,
          ...(accountingClientId && { accountingClient: accountingClientId }),
          ...(fiscalYear && { fiscalYear })
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch balance sheet';
    }
  },

  getIncomeStatement: async (startDate, endDate, accountingClientId = null, segment = null) => {
    try {
      const response = await axiosInstance.get('/general-ledger/income-statement', {
        params: {
          startDate,
          endDate,
          ...(accountingClientId && { accountingClient: accountingClientId }),
          ...(segment && { segment })
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch income statement';
    }
  },

  // ✅ add this
  getIncomeStatementComparative: async (startDate, endDate, compareStartDate, compareEndDate, accountingClientId = null, fiscalYear = null, segment = null) => {
    try {
      const response = await axiosInstance.get('/general-ledger/income-statement-comparative', {
        params: {
          startDate,
          endDate,
          compareStartDate,
          compareEndDate,
          ...(accountingClientId && { accountingClient: accountingClientId }),
          ...(fiscalYear && { fiscalYear }),
          ...(segment && { segment })
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch income statement comparative';
    }
  },

  // NEW: Cash Flow Statement method
  getCashFlowStatement: async (startDate, endDate, accountingClientId = null, fiscalYear = null) => {
    try {
      const response = await axiosInstance.get('/general-ledger/cash-flow-statement', {
        params: { 
          startDate, 
          endDate,
          ...(accountingClientId && { accountingClient: accountingClientId }),
          ...(fiscalYear && { fiscalYear })
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch cash flow statement';
    }
  },
    // Add this to your API methods
getWorksheet: async (startDate, endDate, accountIds) => {
  try {
    const response = await axiosInstance.get('/general-ledger/worksheet', {
      params: { 
        startDate, 
        endDate, 
        accountIds: Array.isArray(accountIds) ? accountIds : [accountIds] 
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to generate worksheet';
  }
},

  getAccountBalance: async (accountId, asOfDate) => {
    try {
      const response = await axiosInstance.get(`/general-ledger/account/${accountId}/balance`, {
        params: { asOfDate }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch account balance';
    }
  },


};

export default generalLedgerAPI;